var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hamburger-cont",on:{"click":_vm.toggleClick}},[_c('svg-icon',{staticClass:"hamburger",class:{'is-active':_vm.isActive},attrs:{"icon-class":"right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }